import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { ReactComponent as AnonymousAvatar } from '../../assets/images/anonymous-avatar.svg';
import { IStyled } from '../../styles/types';

interface IProps extends IStyled {
  size: number;
  picture?: string;
}

const Container = styled.div`
  flex: 0 0 auto;
  object-fit: contain;
  user-select: none;
`;
const Picture = styled.img`
  border-radius: 50%;
`;

const Avatar = forwardRef<HTMLDivElement, IProps>(
  ({ size, picture, className }, ref) => {
    return (
      <Container
        ref={ref}
        className={className}
        style={{ width: size, height: size }}
      >
        {picture ? (
          <Picture src={picture} alt="creator" width={size} height={size} />
        ) : (
          <AnonymousAvatar width={size} height={size} />
        )}
      </Container>
    );
  },
);

export default Avatar;
